import { Box, SvgIcon, Tooltip, useTheme } from '@mui/material'

export type ViolationBadgeProps = {
  size?: number
  tooltip: string
  fillColor?: string
}

export function ViolationBadge(props: ViolationBadgeProps) {
  const theme = useTheme()
  const { size = 20, fillColor = theme.vars.palette.warning.main } = props

  return (
    <Tooltip title={props.tooltip} placement="top">
      <Box sx={{ width: size, height: size }}>
        <SvgIcon viewBox="0 0 20 20">
          <path
            fill={fillColor}
            d="M10.001 1.66699c4.6023 0 8.333 3.73064 8.333 8.33301 0 4.6024-3.7307 8.333-8.333 8.333-4.6024 0-8.33303-3.7306-8.33303-8.333 0-4.60237 3.73063-8.33301 8.33303-8.33301ZM7.3623 6.02246c-.34961-.09526-.6939.16801-.69433.53027V15h1.25v-3.0693l6.52933-2.96781c.4684-.21322.4136-.89579-.083-1.03125l-7.002-1.90918Z"
          />
        </SvgIcon>
      </Box>
    </Tooltip>
  )
}
